<template>
  <div class="coupon-code-setting">
    <a-card :bordered="false" title="预约设置">
      <a-tabs style="background-color: white;" :activeKey="activateKey" @tabClick="onTabClickEvent">
        <a-tab-pane tab="预约信息" key="tab1">
          <InfoComponents @success="onSaveSuccess" :initState="updateEditStatus"
                          :activateKey="activateKey"></InfoComponents>
        </a-tab-pane>
        <a-tab-pane tab="预约套餐" key="tab2" :disabled="!edit">
          <PackageComponents :activateKey="activateKey"></PackageComponents>
        </a-tab-pane>
        <a-tab-pane tab="附加商品" key="tab3">
          <SubjoinComponents :activateKey="activateKey"></SubjoinComponents>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import InfoComponents from './components/InfoComponents'
import PackageComponents from './components/PackageComponents'
import SubjoinComponents from './components/SubjoinComponents'

export default {
  name: 'CouponCodeSetting',
  components: { PackageComponents, InfoComponents, SubjoinComponents },
  data() {
    return {
      activateKey: 'tab1',
      edit: false//编辑状态
    }
  },
  created() {
    const type = this.getPageParams().type
    this.activateKey = (type === 2 || type === '2') ? 'tab2' : 'tab1'
    if (type == 2) {
      this.edit = true
    }
  },
  mounted() {
  },
  methods: {
    //改变当前状态
    updateEditStatus(state) {
      this.getLogUtils().logWithTag('updateEditStatus edit', state)
      this.edit = state
    },
    onTabClickEvent(activateKey) {
      this.activateKey = activateKey
    },
    onSaveSuccess() {
      this.edit = true
      this.activateKey = 'tab2'
    }
  }

}
</script>
<style lang="less">
.coupon-code-setting {
  .ant-card-body {
    padding-top: 1px;
  }
}
</style>